<div class="card-container">
  <div class="card">
    @if (idImages && idImages.front) {
      <div class="id-photo-container">
        <div class="wrapper" [style]="frontRotationStyle">
          <img
            data-private
            class="id-image"
            src="data:image/jpg;base64,{{ idImages.front }}"
            alt="front of identity document"
            />
          </div>
        </div>
      }
      @if (!idImages || !idImages.front) {
        <div class="id-photo-container">
          <div class="wrapper" [style]="frontRotationStyle">
            <img class="id-image" src="assets/images/license-front.svg" alt="front of identity document" />
          </div>
        </div>
      }
      <div class="id-front-container">
        <span class="id-sub-heading">ID Front</span>
        <div class="buttons-container">
          <button class="unfold-button front">
            <mat-icon
              data-testid="unfold-more-front"
              class="mat-icon__unfold"
              matTooltip="Expand"
              matTooltipClass="unfold-more-front-icon-tooltip"
              (click)="enlargeFrontImage()"
              (keypress)="enlargeFrontImage()"
              >
            </mat-icon>
            <span class="cdk-visually-hidden">Expand Image</span>
          </button>
          <button class="rotate-button front">
            <mat-icon
              class="mat-icon__rotate"
              data-testid="rotate-button"
              matTooltip="Rotate"
              matTooltipClass="rotate-icon-tooltip"
              (click)="onRotateFront()"
              (keypress)="onRotateFront()"
              >
            </mat-icon>
            <span class="cdk-visually-hidden">Rotate Image by 90 degrees to left</span>
          </button>
        </div>
      </div>
    </div>

    <div class="card">
      @if (idImages && idImages.back) {
        <div class="id-photo-container">
          <div class="wrapper" [style]="backRotationStyle">
            <img
              class="id-image"
              data-private
              src="data:image/jpg;base64,{{ idImages.back }}"
              alt="back ID image"
              />
            </div>
          </div>
        }
        @if (!idImages || !idImages.back) {
          <div class="id-photo-container">
            <div class="wrapper" [style]="backRotationStyle">
              <img class="id-image" src="assets/images/license-back.svg" alt="back of identity document" />
            </div>
          </div>
        }
        <div class="id-back-container">
          <span class="id-sub-heading">ID Back</span>
          <div class="buttons-container">
            <button class="unfold-button back">
              <mat-icon
                class="mat-icon__unfold"
                data-testid="unfold-more-back"
                matTooltip="Expand"
                matTooltipClass="unfold-more-back-icon-tooltip"
                (click)="enlargeBackImage()"
                (keypress)="enlargeBackImage()"
                >
              </mat-icon>
              <span class="cdk-visually-hidden">Expand Image</span>
            </button>
            <button class="rotate-button back">
              <mat-icon
                class="mat-icon__rotate"
                data-testid="rotate-button"
                matTooltip="Rotate"
                matTooltipClass="rotate-icon-tooltip"
                (click)="onRotateBack()"
                (keypress)="onRotateBack()"
                >
              </mat-icon>
              <span class="cdk-visually-hidden">Rotate Image by 90 degrees to left</span>
            </button>
          </div>
        </div>
      </div>
    </div>
